import { render, staticRenderFns } from "./MarkerAttributeEditor.vue?vue&type=template&id=04b16196"
import script from "./MarkerAttributeEditor.vue?vue&type=script&lang=js"
export * from "./MarkerAttributeEditor.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MarkerAttributeEditor.vue?vue&type=style&index=1&id=04b16196&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports